import { Link } from 'react-router-dom';

const partners = [
  { name: 'MUFG', color: 'text-foreground-300' },
  { name: 'SMBC', color: 'text-foreground-300' },
  { name: 'MIZUHO', color: 'text-foreground-300' },
  { name: 'VISA', color: 'text-foreground-300' },
  { name: 'Mastercard', color: 'text-foreground-300' },
  { name: 'JCB', color: 'text-foreground-300' },
  { name: 'NTT DATA', color: 'text-foreground-300' },
  { name: 'NEC', color: 'text-foreground-300' },
];

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto text-center">
        {/* Main CTA */}
        <div className="mb-16 md:mb-20">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-foreground-950 tracking-[0.06em] leading-[1.3]">
            パートナー企業様へ
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-500 tracking-[0.08em] font-sans font-light">
            API連携のご相談はこちら
          </p>
          <div className="mt-8">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-800 text-accent-400 text-sm md:text-base tracking-[0.08em] font-sans font-medium hover:bg-primary-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              お問合わせ
              <i className="ri-arrow-right-line text-lg" />
            </Link>
          </div>
        </div>

        {/* Partner Logos Strip */}
        <div className="overflow-hidden border-t border-background-200 pt-10 md:pt-14">
          <p className="text-xs text-foreground-400 tracking-[0.15em] font-sans font-light mb-8">
            導入実績
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
            {partners.map((partner) => (
              <span
                key={partner.name}
                className={`text-xs md:text-sm font-sans font-medium tracking-[0.15em] opacity-40 hover:opacity-60 transition-opacity duration-300 ${partner.color}`}
              >
                {partner.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}